import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppComponent } from 'src/app/app.component';
import { Router } from '@angular/router';
import { NavigationService } from '../../services/navigation.service';

@Component({
	selector: 'app-order-not-exist-modal',
	templateUrl: './order-not-exist-modal.component.html',
	styleUrls: ['./order-not-exist-modal.component.scss'],
})
export class OrderNotExistModalComponent implements OnInit {
	public isInMenu = false;

	constructor(public modalCtrl: ModalController, private router: Router, private navSvc: NavigationService) {
		this.isInMenu = this.router.url.includes('menu');
	}

	static async show(modalCtrl: ModalController) {
		const modal = await modalCtrl.create({
			cssClass: AppComponent.largeScreen ? 'sign-modal' : 'auto-height',
			component: OrderNotExistModalComponent,
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		return await modal.onDidDismiss();
	}
	ngOnInit() {}

	toMap() {
		this.modalCtrl.dismiss();
		this.navSvc.map();
	}
}
